// vitest automatically sets NODE_ENV to 'test' when running tests
export const isTestEnv = (): boolean => (typeof process !== "undefined" ? process.env["NODE_ENV"] === "test" : false);
